export default __webpack_public_path__ + "static/media/line-v-15.ebb7ad3a.png";